import { atom } from 'recoil';

const STORAGE_KEY = 'fastPropertiesFilters_v1';

// Date-typed filter fields. JSON round-trips Dates as ISO strings, so we revive
// them on hydrate — react-datepicker throws RangeError when handed a string.
const DATE_FIELDS = ['availFrom', 'availTo', 'builtAfter', 'builtBefore', 'renovatedAfter'];
const FORWARD_DATE_FIELDS = new Set(['availFrom', 'availTo']);

export const DEFAULT_FAST_PROPERTIES_FILTERS = {
  cityId: null,
  search: '',
  neighborhoodIds: [],
  zipCodes: [],
  minPrice: null,
  maxPrice: null,
  bedTypes: [],
  minBaths: null,
  amenities: [],
  excludeAmenities: [],
  policies: [],
  minEscort: null,
  minSend: null,
  minBonus: null,
  minSqft: null,
  availFrom: null,
  availTo: null,
  builtAfter: null,
  builtBefore: null,
  renovatedAfter: null,
  onlyAvailable: true,
  sort: 'built_year_desc',
  limit: 24,
  offset: 0,
  drawnShape: null, // GeoJSON polygon from map draw tool; null = no shape filter
};

// Hydrates from localStorage on init and mirrors every change back to it,
// so user-applied filters survive refresh / navigation until they hit Clear.
const localStorageEffect = ({ setSelf, onSet }) => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      const now = new Date();
      for (const key of DATE_FIELDS) {
        if (parsed[key] == null) continue;
        const d = new Date(parsed[key]);
        if (Number.isNaN(d.getTime()))           parsed[key] = null;
        else if (FORWARD_DATE_FIELDS.has(key) && d < now) parsed[key] = null;
        else                                      parsed[key] = d;
      }
      // Spread over DEFAULT_FAST_PROPERTIES_FILTERS so fields added in future schema versions
      // get sane values. Reset offset — pagination shouldn't survive refresh.
      setSelf({ ...DEFAULT_FAST_PROPERTIES_FILTERS, ...parsed, offset: 0 });
    }
  } catch (_) { /* ignore malformed storage */ }

  onSet((newValue, _old, isReset) => {
    try {
      if (isReset) localStorage.removeItem(STORAGE_KEY);
      else         localStorage.setItem(STORAGE_KEY, JSON.stringify(newValue));
    } catch (_) { /* quota / private-mode: ignore */ }
  });
};

export const fastPropertiesFilterAtom = atom({
  key: 'fastPropertiesFilter',
  default: DEFAULT_FAST_PROPERTIES_FILTERS,
  effects: [localStorageEffect],
});
